const hoverLabelFix = (field, input) => {
	if (input.val() !== '') {
		field.addClass('active');
	}
	input.on('focus', function () {
		field.addClass('active');
	});
	input.on('keyup', function () {
		if (input.val() !== '') {
			field.addClass('active');
		}
	});
	input.on('change', function () {
		if (input.val() !== '') {
			field.addClass('active');
		}
	});
	input.on('blur', function () {
		if (input.val() === '') {
			field.removeClass('active');
		}
	});
};

export default hoverLabelFix;
